export default __webpack_public_path__ + "static/media/figmaback.e155b20d.svg";